import { connect } from 'react-redux';
import {
  addActivityGroupToSelection,
  removeActivityGroupFromSelection
} from '../../redux/reducers/selectedActivityGroups';

import ActivityGroupItem from './ActivityGroupItem';

const getSelectedActivityGroups = state => state.selectedActivityGroups;

const mapStateToProps = state => ({
  filters: getSelectedActivityGroups(state)
});

const actionCreators = {
  removeActivityGroupFromSelection,
  addActivityGroupToSelection
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  filters: stateProps.filters,
  onClick: () =>
    stateProps.filters.includes(ownProps.item.id)
      ? dispatchProps.removeActivityGroupFromSelection(ownProps.item.id)
      : dispatchProps.addActivityGroupToSelection(ownProps.item.id)
});

export default connect(mapStateToProps, actionCreators, mergeProps)(ActivityGroupItem);



// WEBPACK FOOTER //
// ./src/components/ActivityGroupItem/ActivityGroupItemContainer.js